module.exports = __webpack_public_path__ + "img/dnevna.36037994.png";